import { css } from '@emotion/core';
import { variables as vars, buttonNormalize, rgba } from '@domain-group/fe-brary';
import { getMessageConfig } from './config';
var SHADOW_COLOUR = rgba(vars.colour.neutral800, 0.15);
var _ref = {
  name: "1qtx2n2",
  styles: "border-top:1px solid;border-bottom:1px solid;border-right:1px solid;"
};
export var message = function message(isToast) {
  return /*#__PURE__*/css("border-left:4px solid;display:flex;position:relative;flex-direction:column;min-height:48px;padding:", vars.global.spacing.mobile.small, ";border-radius:5px;color:", vars.colour.neutral700, ";word-break:break-word;", isToast ? /*#__PURE__*/css("box-shadow:0px 1px 3px 0px ", SHADOW_COLOUR, ",0px 3px 6px 0px ", SHADOW_COLOUR, ";") : _ref, " &:not(:last-child){margin-bottom:", vars.global.spacing.mobile.xsmall, ";}");
};
export var messageIs = function messageIs(type, isInteractive) {
  var config = getMessageConfig(type);
  return /*#__PURE__*/css("background-color:", config.background, ";border-color:", config.primary, ";", isInteractive && /*#__PURE__*/css("transition:background 0.1s ease-in-out;&:hover,&:focus{background:", config.hover, ";}"), " a,button,svg{color:", config.primary, ";}");
};
export var noBorders = {
  name: "pqkswz",
  styles: "border-color:none;border:none;"
};
export var messageContent = {
  name: "obx8co",
  styles: "display:flex;@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){flex:1;}"
};
export var messageIcon = /*#__PURE__*/css("display:flex;flex:0 0;align-items:center;justify-content:center;margin-right:", vars.global.spacing.mobile.small, ";");
var _ref2 = {
  name: "35ezg3",
  styles: "font-weight:600;"
};
export var messageHeadline = function messageHeadline(isToast, hasDetail) {
  return /*#__PURE__*/css(!isToast && hasDetail && _ref2, ";flex:1 1;padding-right:", vars.global.spacing.mobile.small, ";");
};
export var messageDetail = /*#__PURE__*/css("padding-top:", vars.global.spacing.mobile.xsmall, ";"); // when we no longer support children, we can remove this param

var _ref3 = {
  name: "12leeri",
  styles: "&::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;}"
};
export var messageAction = function messageAction(isWholeMessageClickable) {
  return /*#__PURE__*/css(buttonNormalize, ";align-self:right;display:flex;flex-shrink:0;align-items:center;font-weight:bold;text-decoration:none;cursor:pointer;", isWholeMessageClickable && _ref3, " &:focus,&:hover{text-decoration:underline;}");
};